import { Component, ChangeDetectionStrategy } from "@angular/core";
import { OrderConfirmationThankYouMessageComponent, OrderGuestRegisterFormComponent } from "@spartacus/order/components";
import { AddToHomeScreenBannerComponent } from "@spartacus/storefront";
import { AsyncPipe } from "@angular/common";
import { TranslatePipe } from "@spartacus/core";

@Component({
    selector: 'cx-order-confirmation-thank-you-message',
    templateUrl: './udx-order-confirmation-thank-you-message.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        OrderGuestRegisterFormComponent,
        AddToHomeScreenBannerComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})  
export class UDXOrderConfirmationThankYouMessageComponent extends OrderConfirmationThankYouMessageComponent {
    
}